'use client';

import React from 'react';

import FitGuideSlidesContext from './FitGuideSlidesContext';

const FitGuideSlidesProvider = ({ value = null, children }) => (
  <FitGuideSlidesContext.Provider value={value}>
    {children}
  </FitGuideSlidesContext.Provider>
);

export default FitGuideSlidesProvider;
